"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerListener = void 0;
var userInteractionEvents = [
    'keydown',
    'touchstart',
    'mousedown',
    'pointerdown',
    'wheel',
    'keydown',
];
var options = {
    passive: true,
};
var ContainerListener = /** @class */ (function () {
    function ContainerListener(onScroll, scrollContainerRef, onUserInteraction) {
        var _this = this;
        if (scrollContainerRef === void 0) { scrollContainerRef = document.documentElement; }
        this.onScroll = onScroll;
        this.scrollContainerRef = scrollContainerRef;
        this.onUserInteraction = onUserInteraction;
        this.userInteracted = function (event) {
            if (_this.onUserInteraction) {
                _this.onUserInteraction(event);
            }
            _this.startListeningToUserScroll();
        };
    }
    ContainerListener.prototype.startListeningToScrollOnUserInteraction = function () {
        var e_1, _a;
        this.scrollContainerRef.removeEventListener('scroll', this.onScroll, options);
        try {
            for (var userInteractionEvents_1 = __values(userInteractionEvents), userInteractionEvents_1_1 = userInteractionEvents_1.next(); !userInteractionEvents_1_1.done; userInteractionEvents_1_1 = userInteractionEvents_1.next()) {
                var event_1 = userInteractionEvents_1_1.value;
                this.scrollContainerRef.addEventListener(event_1, this.userInteracted, options);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (userInteractionEvents_1_1 && !userInteractionEvents_1_1.done && (_a = userInteractionEvents_1.return)) _a.call(userInteractionEvents_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    ContainerListener.prototype.stopListeningToAll = function () {
        var e_2, _a;
        this.scrollContainerRef.removeEventListener('scroll', this.onScroll, options);
        try {
            for (var userInteractionEvents_2 = __values(userInteractionEvents), userInteractionEvents_2_1 = userInteractionEvents_2.next(); !userInteractionEvents_2_1.done; userInteractionEvents_2_1 = userInteractionEvents_2.next()) {
                var event_2 = userInteractionEvents_2_1.value;
                this.scrollContainerRef.removeEventListener(event_2, this.userInteracted, options);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (userInteractionEvents_2_1 && !userInteractionEvents_2_1.done && (_a = userInteractionEvents_2.return)) _a.call(userInteractionEvents_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    ContainerListener.prototype.startListeningToUserScroll = function () {
        var e_3, _a;
        this.scrollContainerRef.addEventListener('scroll', this.onScroll, options);
        try {
            for (var userInteractionEvents_3 = __values(userInteractionEvents), userInteractionEvents_3_1 = userInteractionEvents_3.next(); !userInteractionEvents_3_1.done; userInteractionEvents_3_1 = userInteractionEvents_3.next()) {
                var event_3 = userInteractionEvents_3_1.value;
                this.scrollContainerRef.removeEventListener(event_3, this.userInteracted, options);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (userInteractionEvents_3_1 && !userInteractionEvents_3_1.done && (_a = userInteractionEvents_3.return)) _a.call(userInteractionEvents_3);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    return ContainerListener;
}());
exports.ContainerListener = ContainerListener;
//# sourceMappingURL=ContainerListener.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/routables/ScrollListeners/ContainerListener.js
// module id = 1010
// module chunks = 8